import { render } from "./CheckCurrP2P.vue?vue&type=template&id=521e2a9e&scoped=true"
import script from "./CheckCurrP2P.vue?vue&type=script&lang=js"
export * from "./CheckCurrP2P.vue?vue&type=script&lang=js"

import "./CheckCurrP2P.vue?vue&type=style&index=0&id=521e2a9e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521e2a9e"]])

export default __exports__